// extracted by mini-css-extract-plugin
module.exports = {"MobileOrderButton":"MobileOrderButton__MobileOrderButton___2IYpK","SidebarOpen":"MobileOrderButton__SidebarOpen___G32lU"};